import { useEffect, useState } from 'react'
import Modal from '../../../../common/components/molecule/Modal/Modal'
import TextInput from '../../../../common/components/atom/TextInput/TextInput'
import ButtonV2 from '../../../../common/components/atom/ButtonV2/Button'
import { Momi } from '../../../../features/momi/types/momiTypes'
import { useUpdateMomi } from '../../../../features/momi/hooks/useMomis'
import { useToast } from '../../../../common/providers/ToastProvider/useToast'

interface RenameMomiDialogProps {
  open: boolean
  momi: Momi | null
  onClose: () => void
}

export default function RenameMomiDialog({ open, momi, onClose }: RenameMomiDialogProps) {
  const [newName, setNewName] = useState(momi?.momi_name ?? '')
  const updateMomi = useUpdateMomi()
  const toast = useToast()

  useEffect(() => {
    if (open) {
      setNewName(momi?.momi_name ?? '')
    }
  }, [open, momi])

  const handleSubmit = () => {
    if (!momi) return
    updateMomi.mutate({
      momiId: momi.momi_id,
      momi: { ...momi, momi_name: newName.trim() },
      callbackFunc: ({ error }) => {
        if (error) {
          toast.error(
            error?.response?.data?.message ?? 'Erreur lors du renommage'
          )
        } else {
          toast.success('MoMi renommé')
          onClose()
        }
      },
    })
  }

  return (
    <Modal isOpen={open} handleClose={onClose}>
      <h2>Renommer le MoMi</h2>
      <div style={{ marginTop: '1rem' }}>
        <TextInput
          label="Nouveau nom"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
        />
      </div>
      <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '1.5rem' }}>
        <ButtonV2
          onClick={onClose}
          variant="outlined"
          color="secondary"
          size="medium"
        >
          Annuler
        </ButtonV2>
        <ButtonV2
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          size="medium"
          disabled={newName.trim() === ''}
        >
          Renommer
        </ButtonV2>
      </div>
    </Modal>
  )
}
